import { AssociatedPersonnelThemeSizeConfig } from './types';

const small: AssociatedPersonnelThemeSizeConfig = {
  associatedPersonnel: {},
};

export default small;
